export default __webpack_public_path__ + "static/media/android-icon-192x192.949cf2e3.png";